import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PresaleFunnelTracking } from "@/features/presale";

/**
 * The funnel-wide shell for `/presale/*` — the same arrangement `join.tsx` uses, and for
 * the same reason: first-touch UTM capture, the analytics alias/identify pair, and per-step
 * page views must mount ONCE for the whole funnel, not per step.
 *
 * Deliberately no `validateSearch`, exactly like `join.tsx`: each step validates its own
 * shape, and leaving this match's search unvalidated is what lets the tracking component
 * read `utm_*` off the landing URL.
 */
export const Route = createFileRoute("/(member)/(public)/presale")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PresaleFunnelTracking>
      <Outlet />
    </PresaleFunnelTracking>
  );
}
